// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAONUSwozTpWsE5c_G3kS9LW79VEhgB6TE",
    authDomain: "eventpix-51918.firebaseapp.com",
    projectId: "eventpix-51918",
    storageBucket: "eventpix-51918.appspot.com",
    messagingSenderId: "126362984692",
    appId: "1:126362984692:web:a3953c14a5c390a97bfea1",
    measurementId: "G-G6S74T90LQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export default app;
